import { useEffect, useState } from 'react';

import LearnSICFooter from '@/components/layout/landing/Footer';
import NavbarNew from '@/components/layout/landing/NavbarNew';
import { Layout, Menu, MenuProps } from 'antd';
import classnames from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';

const ProfileLayout = (props) => {
  const router = useRouter();
  const tab = router.pathname;
  type MenuItem = Required<MenuProps>['items'][number];
  const { Content, Sider } = Layout;

  const isLogin = (): void => {
    const token = window.localStorage.getItem('token');
    if (!token) {
      window.location.pathname = '/login';
    }
  };

  useEffect(() => {
    isLogin();
  }, []);

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    className?: string,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group'
  ): MenuItem {
    return {
      key,
      icon,
      className,
      children,
      label,
      type,
    } as MenuItem;
  }

  const items: MenuItem[] = [
    getItem(
      <Link href="/profile/dashboard" prefetch={false}>
        <a
          className={classnames(
            'dropdown-profile-menu nav-link pb-0 pl-2 font-weight-500',
            tab === '/profile/dashboard' && 'text-primary'
          )}
        >
          Dashboard
        </a>
      </Link>,
      '0',
      'pl-0',
      <img
        src={
          tab !== '/profile/dashboard'
            ? '/images/svgs/dashboard/dashboard stroke.svg'
            : '/images/svgs/dashboard/dashboard blue.svg'
        }
        className="mt-1"
        width={'18px'}
        height="18px"
      />
    ),
    // tab === "/profile/dashboard" && 'bg-primary text-white border-14'
    getItem(
      <Link href="/profile/my-course" prefetch={false}>
        <a
          className={classnames(
            'dropdown-profile-menu nav-link pb-0 pl-2 font-weight-500',
            tab === '/profile/my-course' && 'text-primary'
          )}
        >
          My Courses
        </a>
      </Link>,
      '1',
      'pl-0',
      <img
        src={
          tab !== '/profile/my-course'
            ? '/images/svgs/dashboard/course stroke.svg'
            : '/images/svgs/dashboard/course blue.svg'
        }
        className="mt-1"
        width={'18px'}
        height="18px"
      />
    ),
    getItem(
      <Link href="/profile/my-attempted-tests" prefetch={false}>
        <a
          className={classnames(
            'dropdown-profile-menu nav-link pb-0 pl-2 font-weight-500',
            tab === '/profile/my-attempted-tests' && 'text-primary'
          )}
        >
          My Mock Test
        </a>
      </Link>,
      '1',
      'pl-0',
      <img
        src={
          tab !== '/profile/my-attempted-tests'
            ? '/images/svgs/dashboard/course stroke.svg'
            : '/images/svgs/dashboard/course blue.svg'
        }
        className="mt-1"
        width={'18px'}
        height="18px"
      />
    ),
    getItem(
      <Link href="/profile/my-assessment" prefetch={false}>
        <a
          className={classnames(
            'dropdown-profile-menu nav-link pb-0 pl-2 font-weight-500',
            tab === '/profile/my-assessment' && 'text-primary'
          )}
        >
          My Assessment
        </a>
      </Link>,
      '1',
      'pl-0',
      <img
        src={
          tab !== '/profile/my-assessment'
            ? '/images/svgs/dashboard/course stroke.svg'
            : '/images/svgs/dashboard/course blue.svg'
        }
        className="mt-1"
        width={'18px'}
        height="18px"
      />
    ),
    // getItem(<Link href="/profile/wishlist" prefetch={false}>
    //     <a className={classnames("dropdown-profile-menu nav-link pb-0 pl-2 font-weight-500", tab === "/profile/wishlist" && 'text-primary')}>
    //         Wishlist
    //     </a>
    // </Link>, '2', 'pl-0', <img src={tab !== "/profile/wishlist" ? "/images/svgs/dashboard/wishlist stroke.svg" : "/images/svgs/dashboard/wishlist blue.svg"} className="mt-1" width={"16px"} height="16px" />),
    getItem(
      <Link href="/purchase-history" prefetch={false}>
        <a
          className={classnames(
            'dropdown-profile-menu nav-link pb-0 pl-2 font-weight-500',
            tab === '/purchase-history' && 'text-primary'
          )}
        >
          Purchase History
        </a>
      </Link>,
      '4',
      'pl-0',
      <img
        src={
          tab !== '/purchase-history'
            ? '/images/svgs/dashboard/order stroke.svg'
            : '/images/svgs/dashboard/order blue.svg'
        }
        className="mt-1"
        width={'18px'}
        height="18px"
      />
    ),
    getItem(
      <Link href="/profile/quiz" prefetch={false}>
        <a
          className={classnames(
            'dropdown-profile-menu nav-link pb-0 pl-2 font-weight-500',
            tab === '/profile/quiz' && 'text-primary'
          )}
        >
          Quiz
        </a>
      </Link>,
      '5',
      'pl-0',
      <img
        src={
          tab !== '/profile/quiz'
            ? '/images/svgs/dashboard/mock test stroke.svg'
            : '/images/svgs/dashboard/mock test blue.svg'
        }
        className="mt-1"
        width={'18px'}
        height="18px"
      />
    ),
    // getItem(<Link href="/refer" prefetch={false}>
    //     <a className={classnames("dropdown-profile-menu nav-link pb-0 pl-2 font-weight-500", tab === "/refer" && 'text-primary')}>
    //         Refer and Earn
    //     </a>
    // </Link>, '5', 'pl-0', <img src="/images/svgs/dashboard/mock test stroke.svg" className="mt-1" width={"18px"} height="18px" />),
    // getItem(<Link href="/profile/my-attempted-tests" prefetch={false}>
    //     <a className={classnames("dropdown-profile-menu nav-link pb-0 pl-2 font-weight-500", tab === "/profile/my-attempted-tests" && 'text-primary')}>
    //         Mock Tests
    //     </a>
    // </Link>, '5', 'pl-0', <img src="/images/svgs/dashboard/mock test stroke.svg" className="mt-1" width={"18px"} height="18px" />),
    getItem(
      <Link href="/profile/settings" prefetch={false}>
        <a
          className={classnames(
            'dropdown-profile-menu nav-link pb-0 pl-2 font-weight-500',
            tab === '/profile/settings' && 'text-primary'
          )}
        >
          Profile & Settings
        </a>
      </Link>,
      '5',
      'pl-0',
      <img
        src={
          tab !== '/profile/settings'
            ? '/images/svgs/dashboard/setting stroke.svg'
            : '/images/svgs/dashboard/setting blue.svg'
        }
        className="mt-1"
        width={'18px'}
        height="18px"
      />
    ),
    // getItem(<a
    //     onClick={(e) => handleLogout(e)}
    //     className="nav-link dropdown-profile-menu pb-0 pl-2"
    // >
    //     Log out
    // </a>, '6', 'pl-0'),
  ];
  const [collapsed, setCollapsed] = useState(true);

  return (
    <div className="profile-layout">
      <NavbarNew IsDashboard />
      <div className="custom-container">
        <div className="row">
          <Layout className="col-lg-2 d-none d-lg-block">
            <Sider
              className=""
              style={{
                overflow: 'auto',
                position: 'fixed',
                top: '128px',
              }}
            >
              <Menu
                className="profile-sidebar"
                defaultSelectedKeys={['1']}
                defaultOpenKeys={['sub1']}
                mode="inline"
                theme="dark"
                inlineCollapsed={collapsed}
                items={items}
              />
            </Sider>
          </Layout>
          <Layout className="col-lg-10 col-sm-12 col-md-12">
            <Content className="bg-white">
              <div
                className="bg-white pt-3"
                style={{
                  paddingLeft: '24px',
                  paddingRight: '24px',
                  paddingBottom: '24px',
                }}
              >
                {props?.children}
              </div>
            </Content>
          </Layout>
        </div>
      </div>
      <LearnSICFooter />
    </div>
  );
};

export default ProfileLayout;
